// Live Supervision page translations
export const liveSupervisionTranslations = {
  en: {
    "pageTitle": "Live Supervision",
    "pageSubtitle": "Monitor and guide active interviews in real-time",
    "noActiveInterviews": "No Active Interviews",
    "noActiveInterviewsDesc": "Active interviews will appear here automatically when participants start",
    "activeCount": "{count} active interview(s)",
    "elapsed": "Elapsed",
    "messages": "Messages",
    "lastMessage": "Last message",
    "supervise": "Supervise",
    "backToDashboard": "Back to Dashboard",
    "backToProject": "Back to Project",
    "liveConversation": "Live Conversation",
    "researcherControls": "Researcher Controls",
    "guidancePlaceholder": "Send guidance to the AI interviewer...",
    "sendGuidance": "Send Guidance",
    "guidanceSent": "Guidance sent successfully",
    "delivered": "Delivered",
    "pending": "Pending",
    "quickActions": "Quick Actions",
    "goDeeper": "Go Deeper",
    "changeTopic": "Change Topic",
    "wrapUp": "Wrap Up",
    "probeEmotions": "Probe Emotions",
    "askFollowUp": "Ask Follow-up",
    "anonymous": "Anonymous",
    "active": "Active",
    "idle": "Idle",
    "completed": "Completed",
    "interviewInfo": "Interview Info",
    "refreshing": "Refreshing...",
    "supervising": "Supervising",
    "guidanceHistory": "Guidance History",
    "noGuidanceSent": "No guidance sent yet",
    "messageCount": "{count} messages",
    "aiInterviewer": "AI Interviewer",
    "backToList": "Back to Supervision",
    "fetchError": "Failed to load interview data",
    "guidanceFailed": "Failed to send guidance",
    "noMessagesYet": "No messages yet",
    "participant": "Participant",
    "participantLabel": "Participant",
    "send": "Send",
    "sending": "Sending...",
    "statusActive": "Active",
    "statusCompleted": "Completed",
    "unknownParticipant": "Unknown Participant",
    "statusLive": "Live",
    "statusStalled": "Stalled",
    "waitingForReply": "Waiting for reply",
    "filterAll": "All",
    "sortBy": "Sort by",
    "sortRecent": "Most recent activity",
    "sortLongest": "Longest running",
    "sortMostMessages": "Most messages",
    "noMatchingInterviews": "No interviews match this filter"
  },
  zh: {
    "pageTitle": "实时监督",
    "pageSubtitle": "实时监控和引导进行中的访谈",
    "noActiveInterviews": "没有进行中的访谈",
    "noActiveInterviewsDesc": "当参与者开始访谈时，活跃的访谈将自动显示在这里",
    "activeCount": "{count} 个进行中的访谈",
    "elapsed": "已用时间",
    "messages": "消息",
    "lastMessage": "最新消息",
    "supervise": "监督",
    "backToDashboard": "返回仪表板",
    "backToProject": "返回项目",
    "liveConversation": "实时对话",
    "researcherControls": "研究者控制面板",
    "guidancePlaceholder": "向AI访谈员发送指导...",
    "sendGuidance": "发送指导",
    "guidanceSent": "指导已成功发送",
    "delivered": "已送达",
    "pending": "待处理",
    "quickActions": "快捷操作",
    "goDeeper": "深入探讨",
    "changeTopic": "更换话题",
    "wrapUp": "结束访谈",
    "probeEmotions": "探索情感",
    "askFollowUp": "追问",
    "anonymous": "匿名",
    "active": "进行中",
    "idle": "空闲",
    "completed": "已完成",
    "interviewInfo": "访谈信息",
    "refreshing": "刷新中...",
    "supervising": "监督中",
    "guidanceHistory": "指导历史",
    "noGuidanceSent": "尚未发送指导",
    "messageCount": "{count} 条消息",
    "aiInterviewer": "AI访谈员",
    "backToList": "返回监督列表",
    "fetchError": "加载访谈数据失败",
    "guidanceFailed": "发送指导失败",
    "noMessagesYet": "暂无消息",
    "participant": "参与者",
    "participantLabel": "参与者",
    "send": "发送",
    "sending": "发送中...",
    "statusActive": "进行中",
    "statusCompleted": "已完成",
    "unknownParticipant": "未知参与者",
    "statusLive": "实时",
    "statusStalled": "停滞",
    "waitingForReply": "等待回复",
    "filterAll": "全部",
    "sortBy": "排序",
    "sortRecent": "最近活动",
    "sortLongest": "最长运行时间",
    "sortMostMessages": "消息最多",
    "noMatchingInterviews": "没有符合此筛选的访谈"
  },
  fr: {
    "pageTitle": "Supervision en direct",
    "pageSubtitle": "Surveillez et guidez les entretiens actifs en temps réel",
    "noActiveInterviews": "Aucun entretien actif",
    "noActiveInterviewsDesc": "Les entretiens actifs apparaîtront ici automatiquement lorsque les participants commenceront",
    "activeCount": "{count} entretien(s) actif(s)",
    "elapsed": "Temps écoulé",
    "messages": "Messages",
    "lastMessage": "Dernier message",
    "supervise": "Superviser",
    "backToDashboard": "Retour au tableau de bord",
    "backToProject": "Retour au projet",
    "liveConversation": "Conversation en direct",
    "researcherControls": "Contrôles du chercheur",
    "guidancePlaceholder": "Envoyer des instructions à l'intervieweur IA...",
    "sendGuidance": "Envoyer les instructions",
    "guidanceSent": "Instructions envoyées avec succès",
    "delivered": "Livré",
    "pending": "En attente",
    "quickActions": "Actions rapides",
    "goDeeper": "Approfondir",
    "changeTopic": "Changer de sujet",
    "wrapUp": "Conclure",
    "probeEmotions": "Explorer les émotions",
    "askFollowUp": "Poser une question de suivi",
    "anonymous": "Anonyme",
    "active": "Actif",
    "idle": "Inactif",
    "completed": "Terminé",
    "interviewInfo": "Informations sur l'entretien",
    "refreshing": "Actualisation...",
    "supervising": "Supervision en cours",
    "guidanceHistory": "Historique des instructions",
    "noGuidanceSent": "Aucune instruction envoyée",
    "messageCount": "{count} messages",
    "aiInterviewer": "Intervieweur IA",
    "backToList": "Retour à la supervision",
    "fetchError": "Échec du chargement des données",
    "guidanceFailed": "Échec de l'envoi de la guidance",
    "noMessagesYet": "Aucun message pour le moment",
    "participant": "Participant",
    "participantLabel": "Participant",
    "send": "Envoyer",
    "sending": "Envoi en cours...",
    "statusActive": "Actif",
    "statusCompleted": "Terminé",
    "unknownParticipant": "Participant inconnu",
    "statusLive": "En direct",
    "statusStalled": "Bloqué",
    "waitingForReply": "En attente de réponse",
    "filterAll": "Tous",
    "sortBy": "Trier par",
    "sortRecent": "Activité récente",
    "sortLongest": "Plus longue durée",
    "sortMostMessages": "Plus de messages",
    "noMatchingInterviews": "Aucun entretien ne correspond à ce filtre"
  },
  nb: {
    "pageTitle": "Direkteovervåking",
    "pageSubtitle": "Overvåk og veilede aktive intervjuer i sanntid",
    "noActiveInterviews": "Ingen aktive intervjuer",
    "noActiveInterviewsDesc": "Aktive intervjuer vil vises her automatisk når deltakerne starter",
    "activeCount": "{count} aktivt/aktive intervju(er)",
    "elapsed": "Forløpt tid",
    "messages": "Meldinger",
    "lastMessage": "Siste melding",
    "supervise": "Overvåk",
    "backToDashboard": "Tilbake til dashbordet",
    "backToProject": "Tilbake til prosjektet",
    "liveConversation": "Direktesamtale",
    "researcherControls": "Forskerkontroller",
    "guidancePlaceholder": "Send veiledning til AI-intervjueren...",
    "sendGuidance": "Send veiledning",
    "guidanceSent": "Veiledning sendt",
    "delivered": "Levert",
    "pending": "Venter",
    "quickActions": "Hurtighandlinger",
    "goDeeper": "Gå dypere",
    "changeTopic": "Bytt emne",
    "wrapUp": "Avslutt",
    "probeEmotions": "Utforsk følelser",
    "askFollowUp": "Still oppfølgingsspørsmål",
    "anonymous": "Anonym",
    "active": "Aktiv",
    "idle": "Inaktiv",
    "completed": "Fullført",
    "interviewInfo": "Intervjuinformasjon",
    "refreshing": "Oppdaterer...",
    "supervising": "Overvåker",
    "guidanceHistory": "Veiledningshistorikk",
    "noGuidanceSent": "Ingen veiledning sendt ennå",
    "messageCount": "{count} meldinger",
    "aiInterviewer": "AI-intervjuer",
    "backToList": "Tilbake til tilsyn",
    "fetchError": "Kunne ikke laste intervjudata",
    "guidanceFailed": "Kunne ikke sende veiledning",
    "noMessagesYet": "Ingen meldinger ennå",
    "participant": "Deltaker",
    "participantLabel": "Deltaker",
    "send": "Send",
    "sending": "Sender...",
    "statusActive": "Aktiv",
    "statusCompleted": "Fullført",
    "unknownParticipant": "Ukjent deltaker",
    "statusLive": "Direkte",
    "statusStalled": "Stoppet",
    "waitingForReply": "Venter på svar",
    "filterAll": "Alle",
    "sortBy": "Sorter etter",
    "sortRecent": "Nyligste aktivitet",
    "sortLongest": "Lengst varig",
    "sortMostMessages": "Flest meldinger",
    "noMatchingInterviews": "Ingen intervjuer matcher dette filteret"
  },
  nl: {
    "pageTitle": "Live supervisie",
    "pageSubtitle": "Monitor en begeleid actieve interviews in realtime",
    "noActiveInterviews": "Geen actieve interviews",
    "noActiveInterviewsDesc": "Actieve interviews verschijnen hier automatisch wanneer deelnemers beginnen",
    "activeCount": "{count} actief/actieve interview(s)",
    "elapsed": "Verstreken tijd",
    "messages": "Berichten",
    "lastMessage": "Laatste bericht",
    "supervise": "Begeleiden",
    "backToDashboard": "Terug naar dashboard",
    "backToProject": "Terug naar project",
    "liveConversation": "Live gesprek",
    "researcherControls": "Onderzoekerscontroles",
    "guidancePlaceholder": "Stuur begeleiding naar de AI-interviewer...",
    "sendGuidance": "Begeleiding versturen",
    "guidanceSent": "Begeleiding succesvol verzonden",
    "delivered": "Afgeleverd",
    "pending": "In afwachting",
    "quickActions": "Snelle acties",
    "goDeeper": "Dieper ingaan",
    "changeTopic": "Onderwerp wijzigen",
    "wrapUp": "Afronden",
    "probeEmotions": "Emoties verkennen",
    "askFollowUp": "Vervolgvraag stellen",
    "anonymous": "Anoniem",
    "active": "Actief",
    "idle": "Inactief",
    "completed": "Voltooid",
    "interviewInfo": "Interviewinformatie",
    "refreshing": "Vernieuwen...",
    "supervising": "Begeleiden",
    "guidanceHistory": "Begeleidingsgeschiedenis",
    "noGuidanceSent": "Nog geen begeleiding verzonden",
    "messageCount": "{count} berichten",
    "aiInterviewer": "AI-interviewer",
    "backToList": "Terug naar supervisie",
    "fetchError": "Kan interviewgegevens niet laden",
    "guidanceFailed": "Kan begeleiding niet verzenden",
    "noMessagesYet": "Nog geen berichten",
    "participant": "Deelnemer",
    "participantLabel": "Deelnemer",
    "send": "Verzenden",
    "sending": "Verzenden...",
    "statusActive": "Actief",
    "statusCompleted": "Voltooid",
    "unknownParticipant": "Onbekende deelnemer",
    "statusLive": "Live",
    "statusStalled": "Vastgelopen",
    "waitingForReply": "Wachten op antwoord",
    "filterAll": "Alle",
    "sortBy": "Sorteer op",
    "sortRecent": "Recentste activiteit",
    "sortLongest": "Langst lopend",
    "sortMostMessages": "Meeste berichten",
    "noMatchingInterviews": "Geen interviews voldoen aan dit filter"
  },
  de: {
    "pageTitle": "Live-Supervision",
    "pageSubtitle": "Aktive Interviews in Echtzeit überwachen und anleiten",
    "noActiveInterviews": "Keine aktiven Interviews",
    "noActiveInterviewsDesc": "Aktive Interviews erscheinen hier automatisch, wenn Teilnehmer beginnen",
    "activeCount": "{count} aktive(s) Interview(s)",
    "elapsed": "Vergangene Zeit",
    "messages": "Nachrichten",
    "lastMessage": "Letzte Nachricht",
    "supervise": "Überwachen",
    "backToDashboard": "Zurück zum Dashboard",
    "backToProject": "Zurück zum Projekt",
    "liveConversation": "Live-Gespräch",
    "researcherControls": "Forscher-Steuerung",
    "guidancePlaceholder": "Anleitung an den KI-Interviewer senden...",
    "sendGuidance": "Anleitung senden",
    "guidanceSent": "Anleitung erfolgreich gesendet",
    "delivered": "Zugestellt",
    "pending": "Ausstehend",
    "quickActions": "Schnellaktionen",
    "goDeeper": "Vertiefen",
    "changeTopic": "Thema wechseln",
    "wrapUp": "Abschließen",
    "probeEmotions": "Emotionen erkunden",
    "askFollowUp": "Nachfrage stellen",
    "anonymous": "Anonym",
    "active": "Aktiv",
    "idle": "Inaktiv",
    "completed": "Abgeschlossen",
    "interviewInfo": "Interview-Informationen",
    "refreshing": "Aktualisierung...",
    "supervising": "Überwachung läuft",
    "guidanceHistory": "Anleitungsverlauf",
    "noGuidanceSent": "Noch keine Anleitung gesendet",
    "messageCount": "{count} Nachrichten",
    "aiInterviewer": "KI-Interviewer",
    "backToList": "Zurück zur Supervision",
    "fetchError": "Interviewdaten konnten nicht geladen werden",
    "guidanceFailed": "Anleitung konnte nicht gesendet werden",
    "noMessagesYet": "Noch keine Nachrichten",
    "participant": "Teilnehmer",
    "participantLabel": "Teilnehmer",
    "send": "Senden",
    "sending": "Wird gesendet...",
    "statusActive": "Aktiv",
    "statusCompleted": "Abgeschlossen",
    "unknownParticipant": "Unbekannter Teilnehmer",
    "statusLive": "Live",
    "statusStalled": "Stockt",
    "waitingForReply": "Warten auf Antwort",
    "filterAll": "Alle",
    "sortBy": "Sortieren nach",
    "sortRecent": "Neueste Aktivität",
    "sortLongest": "Längste Dauer",
    "sortMostMessages": "Meiste Nachrichten",
    "noMatchingInterviews": "Keine Interviews entsprechen diesem Filter"
  },
  es: {
    "pageTitle": "Supervisión en vivo",
    "pageSubtitle": "Monitorea y guía las entrevistas activas en tiempo real",
    "noActiveInterviews": "No hay entrevistas activas",
    "noActiveInterviewsDesc": "Las entrevistas activas aparecerán aquí automáticamente cuando los participantes comiencen",
    "activeCount": "{count} entrevista(s) activa(s)",
    "elapsed": "Tiempo transcurrido",
    "messages": "Mensajes",
    "lastMessage": "Último mensaje",
    "supervise": "Supervisar",
    "backToDashboard": "Volver al panel",
    "backToProject": "Volver al proyecto",
    "liveConversation": "Conversación en vivo",
    "researcherControls": "Controles del investigador",
    "guidancePlaceholder": "Enviar instrucciones al entrevistador IA...",
    "sendGuidance": "Enviar instrucciones",
    "guidanceSent": "Instrucciones enviadas con éxito",
    "delivered": "Entregado",
    "pending": "Pendiente",
    "quickActions": "Acciones rápidas",
    "goDeeper": "Profundizar",
    "changeTopic": "Cambiar de tema",
    "wrapUp": "Concluir",
    "probeEmotions": "Explorar emociones",
    "askFollowUp": "Hacer pregunta de seguimiento",
    "anonymous": "Anónimo",
    "active": "Activo",
    "idle": "Inactivo",
    "completed": "Completado",
    "interviewInfo": "Información de la entrevista",
    "refreshing": "Actualizando...",
    "supervising": "Supervisando",
    "guidanceHistory": "Historial de instrucciones",
    "noGuidanceSent": "Aún no se han enviado instrucciones",
    "messageCount": "{count} mensajes",
    "aiInterviewer": "Entrevistador IA",
    "backToList": "Volver a supervisión",
    "fetchError": "Error al cargar datos de entrevista",
    "guidanceFailed": "Error al enviar orientación",
    "noMessagesYet": "Aún no hay mensajes",
    "participant": "Participante",
    "participantLabel": "Participante",
    "send": "Enviar",
    "sending": "Enviando...",
    "statusActive": "Activo",
    "statusCompleted": "Completado",
    "unknownParticipant": "Participante desconocido",
    "statusLive": "En vivo",
    "statusStalled": "Detenido",
    "waitingForReply": "Esperando respuesta",
    "filterAll": "Todos",
    "sortBy": "Ordenar por",
    "sortRecent": "Actividad reciente",
    "sortLongest": "Mayor duración",
    "sortMostMessages": "Más mensajes",
    "noMatchingInterviews": "Ninguna entrevista coincide con este filtro"
  },
  pt: {
    "pageTitle": "Supervisão ao vivo",
    "pageSubtitle": "Monitore e oriente entrevistas ativas em tempo real",
    "noActiveInterviews": "Nenhuma entrevista ativa",
    "noActiveInterviewsDesc": "As entrevistas ativas aparecerão aqui automaticamente quando os participantes começarem",
    "activeCount": "{count} entrevista(s) ativa(s)",
    "elapsed": "Tempo decorrido",
    "messages": "Mensagens",
    "lastMessage": "Última mensagem",
    "supervise": "Supervisionar",
    "backToDashboard": "Voltar ao painel",
    "backToProject": "Voltar ao projeto",
    "liveConversation": "Conversa ao vivo",
    "researcherControls": "Controles do pesquisador",
    "guidancePlaceholder": "Enviar orientação ao entrevistador IA...",
    "sendGuidance": "Enviar orientação",
    "guidanceSent": "Orientação enviada com sucesso",
    "delivered": "Entregue",
    "pending": "Pendente",
    "quickActions": "Ações rápidas",
    "goDeeper": "Aprofundar",
    "changeTopic": "Mudar de assunto",
    "wrapUp": "Encerrar",
    "probeEmotions": "Explorar emoções",
    "askFollowUp": "Fazer pergunta de acompanhamento",
    "anonymous": "Anônimo",
    "active": "Ativo",
    "idle": "Inativo",
    "completed": "Concluído",
    "interviewInfo": "Informações da entrevista",
    "refreshing": "Atualizando...",
    "supervising": "Supervisionando",
    "guidanceHistory": "Histórico de orientações",
    "noGuidanceSent": "Nenhuma orientação enviada ainda",
    "messageCount": "{count} mensagens",
    "aiInterviewer": "Entrevistador IA",
    "backToList": "Voltar à supervisão",
    "fetchError": "Falha ao carregar dados da entrevista",
    "guidanceFailed": "Falha ao enviar orientação",
    "noMessagesYet": "Nenhuma mensagem ainda",
    "participant": "Participante",
    "participantLabel": "Participante",
    "send": "Enviar",
    "sending": "Enviando...",
    "statusActive": "Ativo",
    "statusCompleted": "Concluído",
    "unknownParticipant": "Participante desconhecido",
    "statusLive": "Ao vivo",
    "statusStalled": "Parado",
    "waitingForReply": "Aguardando resposta",
    "filterAll": "Todos",
    "sortBy": "Ordenar por",
    "sortRecent": "Atividade recente",
    "sortLongest": "Mais longa duração",
    "sortMostMessages": "Mais mensagens",
    "noMatchingInterviews": "Nenhuma entrevista corresponde a este filtro"
  },
  ja: {
    "pageTitle": "ライブ監督",
    "pageSubtitle": "進行中のインタビューをリアルタイムで監視・指導",
    "noActiveInterviews": "アクティブなインタビューはありません",
    "noActiveInterviewsDesc": "参加者が開始すると、アクティブなインタビューが自動的にここに表示されます",
    "activeCount": "{count} 件のアクティブなインタビュー",
    "elapsed": "経過時間",
    "messages": "メッセージ",
    "lastMessage": "最新のメッセージ",
    "supervise": "監督する",
    "backToDashboard": "ダッシュボードに戻る",
    "backToProject": "プロジェクトに戻る",
    "liveConversation": "ライブ会話",
    "researcherControls": "研究者コントロール",
    "guidancePlaceholder": "AIインタビュアーにガイダンスを送信...",
    "sendGuidance": "ガイダンスを送信",
    "guidanceSent": "ガイダンスが正常に送信されました",
    "delivered": "配信済み",
    "pending": "保留中",
    "quickActions": "クイックアクション",
    "goDeeper": "深掘りする",
    "changeTopic": "トピックを変更",
    "wrapUp": "まとめる",
    "probeEmotions": "感情を探る",
    "askFollowUp": "フォローアップ質問",
    "anonymous": "匿名",
    "active": "アクティブ",
    "idle": "アイドル",
    "completed": "完了",
    "interviewInfo": "インタビュー情報",
    "refreshing": "更新中...",
    "supervising": "監督中",
    "guidanceHistory": "ガイダンス履歴",
    "noGuidanceSent": "まだガイダンスは送信されていません",
    "messageCount": "{count} 件のメッセージ",
    "aiInterviewer": "AIインタビュアー",
    "backToList": "監督一覧に戻る",
    "fetchError": "インタビューデータの読み込みに失敗しました",
    "guidanceFailed": "ガイダンスの送信に失敗しました",
    "noMessagesYet": "まだメッセージがありません",
    "participant": "参加者",
    "participantLabel": "参加者",
    "send": "送信",
    "sending": "送信中...",
    "statusActive": "進行中",
    "statusCompleted": "完了",
    "unknownParticipant": "不明な参加者",
    "statusLive": "ライブ",
    "statusStalled": "停滞",
    "waitingForReply": "返信待ち",
    "filterAll": "すべて",
    "sortBy": "並び替え",
    "sortRecent": "最近のアクティビティ",
    "sortLongest": "実行時間が長い順",
    "sortMostMessages": "メッセージが多い順",
    "noMatchingInterviews": "この条件に一致する面談はありません"
  },
  ar: {
    "pageTitle": "الإشراف المباشر",
    "pageSubtitle": "راقب وأرشد المقابلات النشطة في الوقت الفعلي",
    "noActiveInterviews": "لا توجد مقابلات نشطة",
    "noActiveInterviewsDesc": "ستظهر المقابلات النشطة هنا تلقائيًا عندما يبدأ المشاركون",
    "activeCount": "{count} مقابلة(مقابلات) نشطة",
    "elapsed": "الوقت المنقضي",
    "messages": "الرسائل",
    "lastMessage": "آخر رسالة",
    "supervise": "إشراف",
    "backToDashboard": "العودة إلى لوحة التحكم",
    "backToProject": "العودة إلى المشروع",
    "liveConversation": "المحادثة المباشرة",
    "researcherControls": "أدوات التحكم للباحث",
    "guidancePlaceholder": "أرسل توجيهات إلى المحاور الذكي...",
    "sendGuidance": "إرسال التوجيهات",
    "guidanceSent": "تم إرسال التوجيهات بنجاح",
    "delivered": "تم التسليم",
    "pending": "قيد الانتظار",
    "quickActions": "إجراءات سريعة",
    "goDeeper": "تعمّق أكثر",
    "changeTopic": "تغيير الموضوع",
    "wrapUp": "إنهاء",
    "probeEmotions": "استكشاف المشاعر",
    "askFollowUp": "طرح سؤال متابعة",
    "anonymous": "مجهول",
    "active": "نشط",
    "idle": "خامل",
    "completed": "مكتمل",
    "interviewInfo": "معلومات المقابلة",
    "refreshing": "جارٍ التحديث...",
    "supervising": "جارٍ الإشراف",
    "guidanceHistory": "سجل التوجيهات",
    "noGuidanceSent": "لم يتم إرسال توجيهات بعد",
    "messageCount": "{count} رسالة(رسائل)",
    "aiInterviewer": "المقابل الذكي",
    "backToList": "العودة إلى الإشراف",
    "fetchError": "فشل تحميل بيانات المقابلة",
    "guidanceFailed": "فشل إرسال التوجيه",
    "noMessagesYet": "لا توجد رسائل بعد",
    "participant": "المشارك",
    "participantLabel": "المشارك",
    "send": "إرسال",
    "sending": "جاري الإرسال...",
    "statusActive": "نشط",
    "statusCompleted": "مكتمل",
    "unknownParticipant": "مشارك غير معروف",
    "statusLive": "مباشر",
    "statusStalled": "متوقف",
    "waitingForReply": "بانتظار الرد",
    "filterAll": "الكل",
    "sortBy": "ترتيب حسب",
    "sortRecent": "النشاط الأحدث",
    "sortLongest": "الأطول مدة",
    "sortMostMessages": "الأكثر رسائل",
    "noMatchingInterviews": "لا توجد مقابلات تطابق هذا الفلتر"
  }
};
